import React from "react";

const ImageContainer = ({ src, alt }) => {
  return (
    <div className="image-wrapper">
      <img src={src} alt={alt || "Image"} className="custom-image" />
    </div>
  );
};

export default ImageContainer;
